import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
// The one global stylesheet: tokens, base, shell, Bootstrap skin, v2 overlay.
// Replaced main.scss + styles/v2/index.scss in Phase 2.2 — see
// docs/design-system/TOKEN_CONTRACT.md §2 for why the order inside it matters.
import './styles/index.scss';
// Tailwind LAST — utilities are single-class selectors, so they only out-rank the
// component styles they replace if they are emitted after them. This import must
// stay the final stylesheet in the file. See audit F16.
import './styles/tailwind.css';
import { ThemeProvider } from './contexts/ThemeContext';
import { SocketProvider } from './contexts/SocketContext';
import { BrandingProvider } from './contexts/BrandingContext';
import { CmsSiteProvider } from './contexts/CmsSiteContext';
import { PlanProvider } from './contexts/PlanContext';
import { ContentProtectionProvider } from './contexts/ContentProtectionContext';
import { BranchProvider } from './contexts/BranchContext';
import { PageTitleProvider } from './contexts/PageTitleContext';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrandingProvider>
        <CmsSiteProvider>
          <PlanProvider>
            <ContentProtectionProvider>
              <BranchProvider>
                <ThemeProvider>
                  <SocketProvider>
                    <PageTitleProvider>
                      <App />
                    </PageTitleProvider>
                  </SocketProvider>
                </ThemeProvider>
              </BranchProvider>
            </ContentProtectionProvider>
          </PlanProvider>
        </CmsSiteProvider>
      </BrandingProvider>
      </GoogleOAuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// The main bundle executed, so the shell booted. But routes lazy-load their own
// chunks AFTER this point — if one of those fails (a stale cached shell pointing
// at a deleted chunk), the inline self-heal guard in index.html needs its attempt
// counter intact to bound the reloads. Clearing it immediately (the old bug) let a
// failed post-mount import re-arm the guard on every reload → infinite loop. So
// clear it only once the app has stayed up long enough for the initial route's
// lazy chunks to have loaded; a genuinely-broken chunk trips the bounded counter
// (and reloads) well before this fires.
try {
  window.setTimeout(function () {
    try { sessionStorage.removeItem('sw-self-heal'); } catch (_) {}
  }, 15000);
} catch (_) {}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ── PWA: Register service worker ──
// Register in all environments so install prompt works in dev too.
// In production Workbox generates the full caching SW; in dev public/sw.js is used.
// A new deploy is picked up silently: the worker calls skipWaiting() on install
// (sw-source.js), and the next load or navigation gets the new build. There is
// deliberately no "new version available" prompt (owner, 2026-10-23).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(() => console.log('[PWA] Service Worker registered'))
      .catch((err) => console.error('[PWA] SW registration failed:', err));
  });
}
